import { render } from "./OFormGroup.vue?vue&type=template&id=0dc029d7"
import script from "./OFormGroup.vue?vue&type=script&lang=js"
export * from "./OFormGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__